import { ColumnDef } from "@tanstack/react-table"
import { ArrowUpDown } from "lucide-react"
import {Button} from "../../../components/UiComponents/button"
import {Admin} from "../../../api/client"

export const createColumns = (
  onDelete: (id: string, name: string) => void

): ColumnDef<Admin>[] => [
  {
    accessorKey: "user.fullName",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          abbr={column.getIsSorted() === "asc" ? `Click to sort from Z - A (descending order)` : `Click to sort from A - Z (ascending order)`}
        >
          Name
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      )
    },
  },
  {
    accessorKey: "user.email",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          abbr={column.getIsSorted() === "asc" ? `Click to sort from Z - A (descending order)` : `Click to sort from A - Z (ascending order)`}
        >
          Email
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      )
    },
  },
  {
    header: "Actions",
    cell: ({ row }) => (

        <Button
          variant="destructive"
          size="sm"
          onClick={() => {
            onDelete(row.original.id, row.original.user?.fullName)
            }}
          abbr="Click to delete this admin"
        >
          Delete
        </Button>
    ),
  },
];
